@if(show){
    <div class="announcement alert alert-info">
        <div class="media">
            <div class="media-body">
                <h4 class="media-heading">{{header}}</h4>
                <span [innerHtml]="body"></span>
            </div>
            @if(cta){
                <div class="media-right cta">
                    <a class="btn btn-primary" href="{{cta}}" target="_blank">{{'learn_more' | translate}}</a>
                </div>
            }
        </div>
    </div>
}
